<template>
	<v-list class="bookmarks-list">
		<div
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.card_id"
			class="bookmarks-list__item"
		>
			<v-list-item-content class="pa-3">
				<router-link
					style="width: 100%"
					class="bookmarks-list__item-link d-flex align-center"
					:to="{
						name: 'posts-by-id',
						params: { id: resourceItem.thread_id },
						query: {
							enable_all_comments: resourceItem.allow_comments ? 1 : 0,
						},
					}"
				>
					<div>
						<h5 class="bookmarks-list__item-title" v-if="resourceItem.thread_title">
							{{ resourceItem.thread_title }}
						</h5>
						<p
							v-html="resourceItem.thread_text"
							class="bookmarks-list__item-text ma-0"
						/>
					</div>
					<Icon type="chevron_right" :size="24" color="#9B9B9B" />
				</router-link>
			</v-list-item-content>
		</div>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	name: 'BookmarkList',
	data() {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		},
	},
}
</script>

<style lang="scss">
.bookmarks-list {
	background-color: transparent !important;

	&__item {
		background-color: #ffffff;
		margin-bottom: 8px;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		display: flex;
		align-items: center;

		&-link {
			text-decoration: none;
			display: flex;
			justify-content: space-between;
			flex-wrap: nowrap;
		}

		&-title {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--accent-color);
			margin-bottom: 8px;
		}

		&-text {
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;

			p {
				margin: 0 !important;
				a {
					color: var(--link);
				}
			}
		}
	}
}
</style>
